import { Component, inject, input } from '@angular/core';
import { Router } from '@angular/router';
import { RidChevron } from '../rid-chevron/rid-chevron';

@Component({
  selector: 'rid-demo-page',
  imports: [RidChevron],
  templateUrl: './rid-demo-page.html',
})
export class RidDemoPage {
  protected readonly $router = inject(Router);

  title = input.required<string>();
  previousRoute = input<string>();
  class = input<string>('grid grid-cols-1 gap-4 min-w-lg');
}
